module.exports = __webpack_public_path__ + "static/media/sfl_8.5fb14470.jpg";